import { TransitionSelector } from './transition-selector';

const selector = {
  TransitionSelector: TransitionSelector
};

export default selector;
